export const TIME_RANGE_STATUS = {
  OUT_OF_RANGE: 'OUT_OF_RANGE',
  IN_RANGE: 'IN_RANGE',
  NEAR_END: 'NEAR_END'
}

export const getCurrentTimeRangeStatus = (
  startTimeValue,
  endTimeValue,
  hoursToSubtract = 0,
  nearEndMinutes = 60
) => {
  if (!startTimeValue || !endTimeValue) return TIME_RANGE_STATUS.OUT_OF_RANGE

  const now = new Date()
  const currentTime = now.getHours() * 60 + now.getMinutes()

  const [startHour, startMin] = startTimeValue.split(':').map(Number)
  const [endHour, endMin] = endTimeValue.split(':').map(Number)

  if ([startHour, startMin, endHour, endMin].some(Number.isNaN)) {
    return TIME_RANGE_STATUS.OUT_OF_RANGE
  }

  const normalizeMinutes = value => ((value % 1440) + 1440) % 1440

  let startTime = normalizeMinutes(startHour * 60 + startMin)
  let endTime = normalizeMinutes(endHour * 60 + endMin - hoursToSubtract * 60)

  const isInvertedRange = startTime > endTime
  if (isInvertedRange) {
    const swappedDuration = startTime - endTime
    const shouldSwapInvertedRange = swappedDuration <= 12 * 60

    if (shouldSwapInvertedRange) {
      const tmp = startTime
      startTime = endTime
      endTime = tmp
    }
  }

  const isOvernightRange = startTime > endTime
  const isInRange = isOvernightRange
    ? currentTime >= startTime || currentTime <= endTime
    : currentTime >= startTime && currentTime <= endTime

  if (!isInRange) {
    return TIME_RANGE_STATUS.OUT_OF_RANGE
  }

  const remainingMinutes = isOvernightRange
    ? currentTime >= startTime
      ? 1440 - currentTime + endTime
      : endTime - currentTime
    : endTime - currentTime

  if (remainingMinutes <= nearEndMinutes) {
    return TIME_RANGE_STATUS.NEAR_END
  }

  return TIME_RANGE_STATUS.IN_RANGE
}

export const isCurrentTimeInRange = (startTimeValue, endTimeValue, hoursToSubtract = 0) => {
  return (
    getCurrentTimeRangeStatus(startTimeValue, endTimeValue, hoursToSubtract) !==
    TIME_RANGE_STATUS.OUT_OF_RANGE
  )
}